module.exports = __webpack_public_path__ + "img/authorityLogo13.dd56b5ee.png";